import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  INDIVIDUO_NEGATIVO_EMPRENDEDOR,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO
} from "./step-constants";

const errores = {
  [ERROR_TECNICO]: {
    img: "error-connectiion.svg",
    title:
      "En este momento no podemos procesar la solicitud por inconvenientes técnicos",
    subtitle: "Por favor, volvé a intentarlo en unos minutos."
  },
  [INDIVIDUO_NEGATIVO]: {
    img: "remote-manager.svg",
    title:
      "Ya recibimos tu información de contacto. Un representante de BBVA se contactará con vos para continuar.",
    subtitle:
      "En breve, un representante de BBVA se comunicará con vos para asesorarte y brindarte información respecto a la apertura de cuentas para Empresas."
  },
  [INDIVIDUO_NEGATIVO_EMPRENDEDOR]: {
    img: "remote-manager.svg",
    title:
      "Ya recibimos tus datos de contacto.",
    subtitle:
      "En breve, un representante de BBVA se comunicará con vos para asesorarte y brindarte información sobre los productos que mejor se adapten a tus necesidades."
  },
  [RECHAZADO_OTROS]: {
    img: "group-11.svg",
    title: "Con los datos proporcionados no pudimos hacer un cálculo online.",
    subtitle:
      "Podés acercarte a cualquiera de nuestras sucursales para recibir información detallada."
  },
  [ERROR_NOSIS]: {
    img: "authorization-error.svg",
    title: "Verificá los datos ingresados",
    subtitle:
      "Desde el botón Volver, podrás regresar a la pantalla anterior para editar los datos ingresados."
  },
  [RECHAZADO]: {
    img: "group-11.svg",
    title:
      "Según los datos que nos proporcionaste no es posible hacer un cálculo online para la Empresa.",
    subtitle: "Regresando al paso anterior podrás verificar y editar tus datos."
  }
};

export default errores;
